import React from 'react';

import Stage from './Stage';

const EditSelectPipelineStage = ({ value: pipelineStage, setValue: setPipelineStage, stages, isInvalid }) => {

    const selectedIndex = pipelineStage ? stages.findIndex((s) => s.id === pipelineStage.id) : 0;

    const goRight = () => {
        const currentIndex = stages.findIndex((o) => o.id === pipelineStage.id);
        if (currentIndex < stages.length - 1) {
            setPipelineStage(stages[currentIndex + 1]);
        }
    };
    const goLeft = () => {
        const currentIndex = stages.findIndex((o) => o.id === pipelineStage.id);
        if (currentIndex > 0) {
            setPipelineStage(stages[currentIndex - 1]);
        }
    };

    const onKeyDown = (event) => {
        // Right arrow
        if (event.keyCode === 39) {
            goRight();
            event.preventDefault();
        }
        // Left arrow
        if (event.keyCode === 37) {
            goLeft();
            event.preventDefault();
        }
    };

    return (
        <div className='crm-editable-field-wrapper' tabIndex={0} onKeyDown={onKeyDown}>
            <div className={`pipeline-stages open ${isInvalid && 'error'}`}>
                <ul>
                    {stages.map((s, i) => (
                        <Stage
                            key={s.id}
                            pipelineStage={s}
                            highlighted={i <= selectedIndex}
                            hasArrow={i < stages.length - 1}
                            onClick={() => setPipelineStage(s)}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default EditSelectPipelineStage;
